import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const successLookup = (cbInfo, response) => {
  // console.log('get users OK response:');
  // console.log(response.data);
  store.dispatch('getUser', response.data);
  if (cbInfo && cbInfo.cbSuccess) {
    cbInfo.cbSuccess(response);
  }
};

// When the request fails
const failedLookup = (cbInfo, response) => {
  // console.log('get users error response:');
  // console.log(response);
  if (cbInfo && cbInfo.cbFail) {
    cbInfo.cbFail(response);
  }
};

export default (spid, userid, cbInfo) => {
  const axiosOptions = {
    timeout: 10000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  const thisurl = `/api/v1/sp/${spid}/user/${userid}`;
  Vue.$http.get(thisurl, axiosOptions)
   .then((response) => {
     successLookup(cbInfo, response);
   })
   .catch((error) => {
     failedLookup(cbInfo, error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/account/getuser.js